import React from 'react';
import HomeContent from '../components/HomeContent';

const Home = () => {
  return <HomeContent page="home" />;
};

export default Home;
